import { ipsos } from ".";

// Láminas 50-54 (Bancos y tarjetas de crédito / Banca digital). Categoría SIN página propia en
// /categorias — nace para la frase de correo del Radar (Fase 5, rubro "banca", categorias 8/31/34),
// no para un componente visual. Fuente: docs/decisiones/2026-09-27-ipsos-2025-desglose-completo.md
// láminas 50/51/52/54.
const P_ES_CLIENTE = "¿Es usted cliente de algún banco?";
const P_MEDIOS_PAGO = "¿Cuáles de estos tipos de medios de pago tiene?";
const P_BUSCA_TARJETA = "¿Qué busca en una tarjeta de crédito?";
const P_BANCA_DIGITAL = "¿Usa bancos 100% digitales o billeteras virtuales?";

export const IPSOS_BANCOS = {
  bancarizado: ipsos(0.966, { lamina: 50, pregunta: P_ES_CLIENTE, base: 400 }),

  tieneTarjetaCredito: ipsos(0.808, {
    lamina: 51,
    pregunta: P_MEDIOS_PAGO,
    base: 386,
    nota: "tarjeta de crédito, una opción de una pregunta multirespuesta",
  }),

  buscaEnTarjeta: {
    beneficiosSupermercados: ipsos(0.654, { lamina: 52, pregunta: P_BUSCA_TARJETA, base: 213 }),
    millas: ipsos(0.6, { lamina: 52, pregunta: P_BUSCA_TARJETA, base: 213 }),
  },

  usaBancaDigital: ipsos(0.757, { lamina: 54, pregunta: P_BANCA_DIGITAL, base: 400 }),
};
